type AuthenticationSource = "shopware";

const idpBySource: Partial<Record<AuthenticationSource, string>> = {
  shopware: window.VITE_OKTA_SHOPWARE_IDP_ID,
};

export const getExternalIdpForCurrentLocation = (): string | undefined => {
  const source = new URLSearchParams(window.location.search).get("from");

  if (source !== "shopware") {
    return undefined;
  }

  const idp = idpBySource[source]?.trim();

  if (!idp) {
    throw new Error("Shopware login requires VITE_OKTA_SHOPWARE_IDP_ID to be configured.");
  }

  return idp;
};
